
import { useNavigate, useLocation } from 'react-router-dom';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      icon: 'ri-home-line',
      activeIcon: 'ri-home-fill',
      label: 'الرئيسية',
      path: '/dashboard'
    },
    {
      icon: 'ri-exchange-line',
      activeIcon: 'ri-exchange-fill',
      label: 'تحويل',
      path: '/transfer'
    },
    {
      icon: 'ri-history-line',
      activeIcon: 'ri-history-fill',
      label: 'السجل',
      path: '/history'
    },
    {
      icon: 'ri-bar-chart-line',
      activeIcon: 'ri-bar-chart-fill',
      label: 'التقارير',
      path: '/reports'
    },
    {
      icon: 'ri-user-line',
      activeIcon: 'ri-user-fill',
      label: 'الملف الشخصي',
      path: '/profile'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-0">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center h-full transition-colors ${
                isActive 
                  ? 'text-blue-600' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <i className={`${isActive ? item.activeIcon : item.icon} text-xl mb-1`}></i>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
